import {PATHS} from "./utils/Paths.links";
import ProfilePage from "../pages/ProfilePage";
import ShopPage from "../pages/ShopPage";
import {ComponentType} from "react";
import DepositPage from "../pages/DepositPage/DepositPage";
import AgreementPage from "../pages/AgreementPage/AgreementPage";
import PrivacyPage from "../pages/ PrivacyPage/ PrivacyPage";
import AboutPage from "../pages/AboutPage/AboutPage";
import MapPage from "../pages/MapPage/MapPage";
import StatsPage from "../pages/StatsPage/StatsPage";
import CasePage from "../pages/CasePage/CasePage";
import GiveawaysPage from "../pages/GiveawaysPage/GiveawaysPage";
import AdminPage from "../pages/AdminPage/AdminPage";

export interface IRoute {
    path: string;
    component: ComponentType;
    exact?: boolean;
    withoutAuth?: boolean,
    childRoutes?: IRoute[]
}

export const Routes: IRoute[] = [
    { path: PATHS.SHOP, exact: true, component: ShopPage, withoutAuth: true },
    { path: PATHS.SHOPLITE, exact: true, component: ShopPage, withoutAuth: true },
    { path: PATHS.SHOPTRIO, exact: true, component: ShopPage, withoutAuth: true },
    { path: PATHS.PROFILE, exact: false, component: ProfilePage, withoutAuth: false },
    { path: PATHS.DEPOSIT, exact: false, component: DepositPage, withoutAuth: false },
    { path: PATHS.AGREEMENT, exact: false, component: AgreementPage, withoutAuth: true },
    { path: PATHS.PRIVACY, exact: false, component: PrivacyPage, withoutAuth: true },
    { path: PATHS.ABOUT, exact: false, component: AboutPage, withoutAuth: true },
    { path: PATHS.MAP, exact: false, component: MapPage, withoutAuth: true },
    { path: PATHS.STATS, exact: false, component: StatsPage, withoutAuth: true },
    { path: PATHS.CASE, exact: false, component: CasePage, withoutAuth: true },
    { path: PATHS.GIVEAWAYS, exact: false, component: GiveawaysPage, withoutAuth: true },
    // доступ перевіряє сервер (AdminGuard); сторінка лише питає /api/admin/me, щоб показати форму
    { path: PATHS.ADMIN, exact: false, component: AdminPage, withoutAuth: false },
];

